<div class="main-driver-card">
  @if (driverInfo != null) {
    <!-- Banner de Cabecera -->
    <div class="driver-banner"></div>

    <!-- Contenedor del Perfil Flotante -->
    <div class="driver-profile-header">
      <div class="logo-container">
        @if (url_photo_driver || driverInfo.dri_url_photo) {
          <img [src]="url_photo_driver || driverInfo.dri_url_photo" alt="Foto Conductor" class="driver-logo-img" />
        } @else {
          <div class="driver-logo-placeholder">
            {{ driverInfo.dri_name.charAt(0) }}{{ driverInfo.dri_last_name.charAt(0) }}
          </div>
        }
      </div>
      <div class="driver-meta-info">
        <h2 class="driver-title">{{ driverInfo.dri_name }} {{ driverInfo.dri_last_name }}</h2>
        <p class="driver-description">
          <i class="pi pi-briefcase text-emerald-500 me-2"></i> {{ driverInfo.com_name || 'Compañía No Asignada' }}
        </p>
        <div class="d-flex gap-2 align-items-center mt-2 flex-wrap">
          <span class="status-badge status-active">
            <i class="pi pi-check-circle me-1"></i> Activo
          </span>
          @if (driverInfo.dri_score !== undefined && driverInfo.dri_score !== null) {
            <span class="status-badge rating-badge">
              <i class="pi pi-star-fill text-warning me-1"></i> {{ driverInfo.dri_score }} / 5.0
            </span>
          }
        </div>
      </div>
    </div>

    <!-- Pestañas de Detalle -->
    <p-tabView>
      <p-tabPanel header="Datos del Conductor">
        <div class="row">
          <!-- Columna Izquierda: Información Personal y de Acceso -->
          <div class="col-12 col-md-7">
            <!-- Tarjeta 1: Información Personal -->
            <div class="detail-card">
              <h3 class="detail-card-title">
                <i class="pi pi-user"></i> Información Personal
              </h3>
              
              <div class="info-row">
                <div class="info-icon-wrapper icon-emerald">
                  <i class="pi pi-phone"></i>
                </div>
                <div class="info-content">
                  <div class="info-label">Teléfono</div>
                  <p class="info-value">{{ driverInfo.dri_phone || 'No registrado' }}</p>
                </div>
              </div>

              <div class="info-row">
                <div class="info-icon-wrapper icon-blue">
                  <i class="pi pi-id-card"></i>
                </div>
                <div class="info-content">
                  <div class="info-label">Número de Licencia</div>
                  <p class="info-value">{{ driverInfo.dri_number_license || 'No registrado' }}</p>
                </div>
              </div>

              <div class="info-row">
                <div class="info-icon-wrapper icon-indigo">
                  <i class="pi pi-home"></i>
                </div>
                <div class="info-content">
                  <div class="info-label">Dirección Residencial</div>
                  <p class="info-value">{{ driverInfo.dri_address || 'No registrado' }}</p>
                </div>
              </div>
            </div>

            <!-- Tarjeta 2: Seguridad y Acceso -->
            <div class="detail-card">
              <h3 class="detail-card-title">
                <i class="pi pi-lock"></i> Seguridad y Acceso
              </h3>

              <div class="info-row">
                <div class="info-icon-wrapper icon-purple">
                  <i class="pi pi-shield"></i>
                </div>
                <div class="info-content">
                  <div class="info-label">Nro. de Seguro Social</div>
                  <p class="info-value">{{ driverInfo.dri_social || 'No registrado' }}</p>
                </div>
              </div>

              <div class="info-row">
                <div class="info-icon-wrapper icon-orange">
                  <i class="pi pi-key"></i>
                </div>
                <div class="info-content">
                  <div class="info-label">Contraseña de Acceso</div>
                  <p class="info-value">•••••••• ({{ driverInfo.dri_password }})</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Columna Derecha: Foto de Perfil Enmarcada -->
          <div class="col-12 col-md-5 d-flex align-items-stretch">
            <div class="detail-card w-100 d-flex flex-column align-items-center justify-content-center text-center">
              <h3 class="detail-card-title w-100 text-start">
                <i class="pi pi-image"></i> Fotografía del Conductor
              </h3>
              <div class="logo-container my-4" style="width: 200px; height: 200px; border-radius: 16px;">
                @if (url_photo_driver || driverInfo.dri_url_photo) {
                  <p-image 
                    [src]="url_photo_driver || driverInfo.dri_url_photo" 
                    alt="Foto de Perfil" 
                    width="200" 
                    height="200" 
                    [preview]="true"
                    imageClass="driver-logo-img w-100 h-100 rounded-3"
                  ></p-image>
                } @else {
                  <div class="driver-logo-placeholder" style="border-radius: 16px; font-size: 4rem;">
                    {{ driverInfo.dri_name.charAt(0) }}
                  </div>
                }
              </div>
              <p class="text-muted small mt-2">Haz clic sobre la imagen para expandir y previsualizar</p>
            </div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Datos del Vehículo">
        @if (driverInfo.vehicle == null) {
          <div class="detail-card text-center py-5">
            <i class="pi pi-car text-muted mb-3" style="font-size: 4rem;"></i>
            <h4 class="text-muted font-semibold">Sin Vehículo Asignado</h4>
            <p class="text-secondary col-md-6 mx-auto mt-2">
              Este conductor actualmente no tiene ningún vehículo registrado en el sistema. Puedes asignarle uno desde el módulo de vehículos.
            </p>
          </div>
        } @else {
          <div class="row">
            <!-- Columna Izquierda: Especificaciones del Vehículo -->
            <div class="col-12 col-md-7">
              <div class="detail-card h-100">
                <h3 class="detail-card-title">
                  <i class="pi pi-car"></i> Información General del Vehículo
                </h3>

                <div class="row">
                  <div class="col-md-6">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-emerald">
                        <i class="pi pi-ticket"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Placa / Patente</div>
                        <p class="info-value font-bold">{{ driverInfo.vehicle.veh_plate }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-blue">
                        <i class="pi pi-bookmark"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Nro. de Registro</div>
                        <p class="info-value">{{ driverInfo.vehicle.veh_num_registration }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-6">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-indigo">
                        <i class="pi pi-info-circle"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Marca y Modelo</div>
                        <p class="info-value">{{ driverInfo.vehicle.veh_brand }} {{ driverInfo.vehicle.veh_model }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-purple">
                        <i class="pi pi-calendar"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Año de Fabricación</div>
                        <p class="info-value">{{ driverInfo.vehicle.veh_anio }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-6">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-orange">
                        <i class="pi pi-palette"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Color</div>
                        <p class="info-value">{{ driverInfo.vehicle.veh_color }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-gray">
                        <i class="pi pi-users"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Capacidad Pasajeros</div>
                        <p class="info-value">{{ driverInfo.vehicle.veh_quantity_person }} Asientos</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Columna Derecha: Estado de Seguridad y Miniatura -->
            <div class="col-12 col-md-5">
              <div class="detail-card h-100">
                <h3 class="detail-card-title">
                  <i class="pi pi-verified"></i> Estatus e Inspección
                </h3>

                <div class="info-row align-items-center mb-4">
                  <div class="info-icon-wrapper" [class.icon-emerald]="driverInfo.vehicle.veh_inspection === 1" [class.icon-gray]="driverInfo.vehicle.veh_inspection !== 1">
                    <i class="pi" [class.pi-check]="driverInfo.vehicle.veh_inspection === 1" [class.pi-times]="driverInfo.vehicle.veh_inspection !== 1"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label">Inspección Técnica</div>
                    <span class="status-badge" [class.status-active]="driverInfo.vehicle.veh_inspection === 1" [class.icon-gray]="driverInfo.vehicle.veh_inspection !== 1" [style.color]="driverInfo.vehicle.veh_inspection === 1 ? '#0f5132' : '#6c757d'" [style.background]="driverInfo.vehicle.veh_inspection === 1 ? '#d1e7dd' : '#f8f9fa'">
                      {{ driverInfo.vehicle.veh_inspection === 1 ? 'Aprobada / Sí' : 'Pendiente / No' }}
                    </span>
                  </div>
                </div>

                <div class="info-row align-items-center mb-4">
                  <div class="info-icon-wrapper" [class.icon-emerald]="driverInfo.vehicle.veh_secure === 1" [class.icon-gray]="driverInfo.vehicle.veh_secure !== 1">
                    <i class="pi" [class.pi-shield]="driverInfo.vehicle.veh_secure === 1" [class.pi-ban]="driverInfo.vehicle.veh_secure !== 1"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label">Seguro Vehicular</div>
                    <span class="status-badge" [class.status-active]="driverInfo.vehicle.veh_secure === 1" [class.icon-gray]="driverInfo.vehicle.veh_secure !== 1" [style.color]="driverInfo.vehicle.veh_secure === 1 ? '#0f5132' : '#6c757d'" [style.background]="driverInfo.vehicle.veh_secure === 1 ? '#d1e7dd' : '#f8f9fa'">
                      {{ driverInfo.vehicle.veh_secure === 1 ? 'Vigente / Sí' : 'No Registrado / No' }}
                    </span>
                  </div>
                </div>

                @if (driverInfo.vehicle.veh_url_photo) {
                  <div class="text-center pt-2">
                    <p-image 
                      [src]="driverInfo.vehicle.veh_url_photo" 
                      alt="Foto Vehículo" 
                      width="100%"
                      [preview]="true"
                      imageClass="rounded border shadow-sm w-100"
                      [style]="{ 'max-height': '120px', 'object-fit': 'cover' }"
                    ></p-image>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </p-tabPanel>

      <p-tabPanel header="Documentos del Conductor">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h4 class="m-0 font-semibold text-color">Expediente de Archivos</h4>
            <p class="text-secondary small m-0">Documentos cargados del conductor para validación administrativa</p>
          </div>
          <p-button 
            (onClick)="dialogNewFile()" 
            label="Agregar Documento" 
            icon="pi pi-plus" 
            severity="success"
            [rounded]="true"
          />
        </div>

        <p-dataView #dv [value]="driverInfo.lstDocument">
          <ng-template pTemplate="list" let-documents>
            <div class="row mt-2">
              <div class="col-12 col-md-6" *ngFor="let doc of documents">
                <div class="doc-item-card d-flex align-items-center gap-3">
                  <div class="doc-icon-wrapper">
                    @if (doc.doc_extension === 'png' || doc.doc_extension === 'jpg' || doc.doc_extension === 'jpeg') {
                      <i class="pi pi-image"></i>
                    } @else {
                      <i class="pi pi-file"></i>
                    }
                  </div>
                  <div class="doc-meta">
                    <div class="doc-title">{{ doc.typ_name }}</div>
                    <div class="doc-subtitle">{{ doc.doc_name || 'Archivo adjunto' }}</div>
                  </div>
                  <div class="d-flex gap-2">
                    <p-button
                      icon="pi pi-download"
                      [rounded]="true"
                      [text]="true"
                      pTooltip="Descargar"
                      tooltipPosition="top"
                      (onClick)="downloadFile(doc.doc_route, doc.doc_name)"
                    />
                    <p-button
                      icon="pi pi-trash"
                      [rounded]="true"
                      [text]="true"
                      severity="danger"
                      pTooltip="Eliminar"
                      tooltipPosition="top"
                      (onClick)="deleteFile(doc)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </p-dataView>
      </p-tabPanel>
    </p-tabView>
  }
</div>

<!-- Modal para Agregar Nuevo Documento -->
<p-dialog
  header="Cargar Nuevo Documento"
  [modal]="true"
  [(visible)]="newFile"
  [style]="{ width: '40rem' }"
  [draggable]="false"
  [resizable]="false"
  styleClass="custom-dialog"
>
  <div class="p-3">
    <div class="logo-upload-box p-4 text-center mb-4">
      <p-fileUpload
        #fileUpload
        mode="basic"
        chooseLabel="Seleccionar Archivo"
        chooseIcon="pi pi-upload"
        [showUploadButton]="false"
        [showCancelButton]="false"
        maxFileSize="7340032"
        (onSelect)="onUploadAuto($event.files, fileUpload)"
        accept="image/png,image/jpeg,application/pdf"
        [multiple]="false"
        styleClass="p-button-outlined p-button-success"
      >
      </p-fileUpload>
      <p class="text-secondary small mt-2 mb-0">Soporta imágenes (PNG, JPG) y documentos PDF hasta 7MB</p>
    </div>

    <div class="mb-4">
      <label class="form-label-edit mb-2 d-block">Tipo de Documento</label>
      <p-dropdown
        [options]="ltsTypeDocument"
        [(ngModel)]="selectedTypeDocument"
        optionLabel="typ_name"
        placeholder="Seleccione el tipo de documento"
        styleClass="largeInput"
        [appendTo]="'body'"
      />
    </div>

    @if (ltsDocument.length > 0) {
      <div class="detail-card p-3 mb-4">
        <h5 class="font-semibold text-color mb-3 small uppercase tracking-wider">Archivo Listo para Cargar</h5>
        <p-table [value]="ltsDocument">
          <ng-template pTemplate="header">
            <tr>
              <th id="th-pre">Vista</th>
              <th id="th-name">Nombre</th>
              <th id="th-type">Tipo</th>
              <th id="th-act" style="width: 4rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-doc let-index="rowIndex">
            <tr>
              <td>
                @if (doc.filstring) {
                  <p-image [src]="doc.filstring" alt="Previsualizar" width="40" height="40" imageClass="rounded border shadow-sm" [style]="{ 'object-fit': 'cover' }"></p-image>
                } @else {
                  <i class="pi pi-file text-emerald-500" style="font-size: 1.5rem"></i>
                }
              </td>
              <td class="text-truncate" style="max-width: 150px;">{{ doc.file.name }}</td>
              <td>{{ doc.typeDocument.typ_name }}</td>
              <td>
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  (onClick)="remeveFile(index)"
                ></p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-end gap-2 pt-2 border-top">
      <p-button label="Cancelar" [outlined]="true" severity="secondary" (onClick)="closeNewFile()" />
      <p-button label="Guardar Documento" severity="success" [disabled]="ltsDocument.length === 0" (onClick)="saveFile()" />
    </div>
  </ng-template>
</p-dialog>
